import serverCall from "../../serverCall";

const GetFeedback = async (page, limit) => {
  const response = await serverCall.get(
    `/feedback/find-all/admin?page=${page}&limit=${limit}`
  );
  return response;
};

const DeleteFeedback = async (id) => {
  const response = await serverCall.delete(`/feedback/admin?feedbackId=${id}`);
  return response;
};

const FeedbackService = {
  GetFeedback,
  DeleteFeedback,
};

export default FeedbackService;
